export default __webpack_public_path__ + "static/do-visuals-size-741c6274f49b61d516de6b03de9c7f16.png";